module.exports = __webpack_public_path__ + "static/aboutfeatpro-c9606a1dc36af835e83ebab3b9fd7b20.png";